module.exports = __webpack_public_path__ + "img/icono-registrar-ticket.3090685a.png";